import { FlowDynamicValueSchema } from 'flow-schema';
import { z } from 'zod';

import { IdentifierNameSchema } from '../../base/keywords.js';

export const FlowArgumentSchema = z.object({
  id: z.string(),
  name: IdentifierNameSchema,
  value: FlowDynamicValueSchema,
});
export type FlowArgument = z.infer<typeof FlowArgumentSchema>;
export type BaseFlowArgument = Omit<FlowArgument, 'id'>;
